import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const LockFinish = ({ value, onChange, id = 'LockFinish', label = 'Lock Finish', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedValue, setSelectedValue] = useState(defaultValue);

    const options = [
        { id: 1, value: 'White', label: 'White' },
        { id: 2, value: 'Black', label: 'Black' },
        { id: 3, value: 'BlackOut/WhiteIn', label: 'Black Out/White In' },
    ];

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedValue(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (options.length > 0 && !selectedValue) {
            const defaultOption = options[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedValue(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, []);

    const handleChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedValue(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedValue}
                onChange={handleChange}
            >
                {options.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedValue === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default LockFinish;
